import { useCallback } from 'react';

// 正数は切り捨て負数は切り上げ、つまり常に絶対値に近づける
// positive numbers are rounded down, negative numbers are rounded up, this means always approaching the absolute value.
export const useFloorOnAbsolute = () => {
  return useCallback((num: number): number => {
    const truncated = Math.trunc(num);
    // -0を0に変換
    // transform -0 to 0
    return Object.is(truncated, -0) ? 0 : truncated;
  }, []);
};

// Should be identical to what the hook returns.
// TODO: Make the hook call this function if the QA risk is not too high
export const floorOnAbsoluteStateless = (num: number): number => {
  const truncated = Math.trunc(num);
  // -0を0に変換
  // transform -0 to 0
  return Object.is(truncated, -0) ? 0 : truncated;
};
